// Size Attribute
export enum EKwikUIInputCurrencySize {
  S = "s",
  M = "m",
  L = "l"
}
export const VKwikUIInputCurrencySize = [
  EKwikUIInputCurrencySize.S,
  EKwikUIInputCurrencySize.M,
  EKwikUIInputCurrencySize.L
] as const;

export type TKwikUIInputCurrencySize =
  (typeof VKwikUIInputCurrencySize)[number];

export enum EKwikUIInputCurrencyType {
  INR = "INR",
  USD = "USD",
  EUR = "EUR",
  GBP = "GBP",
  JPY = "JPY",
  CNY = "CNY",
  AUD = "AUD",
  CAD = "CAD"
}
export const VKwikUIInputCurrencyType = [
  null,
  EKwikUIInputCurrencyType.INR,
  EKwikUIInputCurrencyType.USD,
  EKwikUIInputCurrencyType.EUR,
  EKwikUIInputCurrencyType.GBP,
  EKwikUIInputCurrencyType.JPY,
  EKwikUIInputCurrencyType.CNY,
  EKwikUIInputCurrencyType.AUD,
  EKwikUIInputCurrencyType.CAD
] as const;

export type TKwikUIInputCurrencyType =
  (typeof VKwikUIInputCurrencyType)[number];
